<template>
  <div id="MakeShareSp" class="make-D3net" >
    <!--結果出力画面-->
    <v-dialog v-model="show" width="80%" class="pa-2" @click:outside="$emit('onClose')">
      <v-container class="modeResult-print" style="background-color: white">
        <h2 class="text-center">共有</h2>
        <div class="mt-4 d-flex flex-column justify-center">
          <v-btn class="rounded-pill white--text" style="background-color: #707070; text-transform: none;" :href="'mailto:?body=「'+aboutLid.ideaTheme + '」の'+$t('アイデア') + ':' + shareurl_">
            <v-icon>mdi-email-fast</v-icon>
            <p class="mb-0">メール</p>
          </v-btn>
          <v-btn class="rounded-pill mx-2 white--text" style="background-color: #1da1f2; text-transform: none;" @click="twitterShare()">
            <v-icon>mdi-twitter</v-icon>
            <p class="mb-0">Twitter</p>
          </v-btn>
          <v-btn class="rounded-pill mx-2 white--text" style="background-color: #1877f2; text-transform: none;" @click="facebookShare()">
            <v-icon>mdi-facebook</v-icon>
            <p class="mb-0">Facebook</p>
          </v-btn>
          <v-btn class="rounded-pill mx-2 white--text" style="background-color: #06c755; text-transform: none;" @click="lineShare()">
            <v-icon>mdi-chat-outline</v-icon>
            <p class="mb-0">LINE</p>
          </v-btn>
        </div>
        <v-col align="center">
          <v-btn small text @click="$emit('onClose')" class="mt-2" style="font-size:18px;">
            <span style="color:#008CFF"></span>閉じる<span style="color:#008CFF"></span>
          </v-btn>
        </v-col>
      </v-container>
    </v-dialog>
  </div>
</template>
 
<script>



export default {
    name: 'MakeShareSp',
    props: ['show', 'idea','namelist'],
    components:{
  },
    data() {
        return {
            shareurl_:""
        }
    },
    created() {
      console.log("共有")
      this.shareurl_ = window.location.href
    },
    methods:{
      twitterShare(){
        //console.log(this.aboutLid)
        let nowURL = window.location.href
        //シェアする画面を設定
        var shareURL = 'https://twitter.com/intent/tweet?text=「' + this.aboutLid.ideaTheme + '」の'+this.$t('アイデア') + '&url=' + nowURL;  
        //シェア用の画面へ移行
        location.href = shareURL
      },
      facebookShare(){
        //console.log(this.aboutLid)
        let nowURL = window.location.href
        //シェアする画面を設定
        var shareURL = 'https://www.facebook.com/share.php?u=' + nowURL;  
        //シェア用の画面へ移行
        location.href = shareURL
      },
      lineShare(){
        //console.log(this.aboutLid)
        let nowURL = window.location.href
        //シェアする画面を設定
        var shareURL = 'https://timeline.line.me/social-plugin/share?url=' + nowURL;  
        //シェア用の画面へ移行
        location.href = shareURL
      }
    },
    computed: {
        aboutLid(){
            return this.$store.state.aboutLid
        },
    },
}
</script>
<style scoped>
/* text:hover { 
    opacity: .6 !important; 
    font-size: 200% !important;
    font-weight: bold !important;
} */
/* div.tooltip {
    position: absolute;
    width: 140px;
    height: 80px !important;
    padding: 8px;
    font: 18px Arial;
    line-height: 24px;
    color: black !important;
    background: whitesmoke !important;
    border: 0px;
    border-radius: 10px !important;
    pointer-events: none;
} */
/* container{
  font-family: 'PT Sans', sans-serif;
  background-color: #eee;
} */
</style>